import { Route, Routes } from "react-router-dom";
import { Space } from "~/lib/types";
import { QueryPackPage } from "~/pages/inventory/query-pack";
import { QueryPackQueryPage } from "~/pages/inventory/query-pack-query";
import { QueryPacksPage } from "~/pages/inventory/query-packs";
import { QueryPacksAddPage } from "~/pages/inventory/query-packs-add";
import { QueryPacksAddDetailPage } from "~/pages/inventory/query-packs-add-detail";
import { QueryPacksAddQueryPage } from "~/pages/inventory/query-packs-add-query";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

export type QueryPacksRoutesProps = {
  space: Space;
  scope: SpaceOrWorkspaceScope;
};

export function QueryPacksRoutes({ space, scope }: QueryPacksRoutesProps) {
  return (
    <Routes>
      <Route index element={<QueryPacksPage {...{ space, scope }} />} />
      <Route path="/add">
        <Route index element={<QueryPacksAddPage {...{ space }} />} />
        <Route path=":policyId">
          <Route index element={<QueryPacksAddDetailPage {...{ space }} />} />
          <Route
            path="queries/:queryId"
            element={<QueryPacksAddQueryPage {...{ space }} />}
          />
        </Route>
      </Route>
      <Route path="/:policyId">
        <Route index element={<QueryPackPage {...{ space, scope }} />} />
        <Route
          path="queries/:queryId"
          element={<QueryPackQueryPage {...{ space, scope }} />}
        />
      </Route>
    </Routes>
  );
}
